
    import Index from   "./_Index.vue"  
    import { Options, Vue } from "vue-class-component";  
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth');  
    @Options({
        name: "Perfil",
        components: { Index},  
    }) 
    export default class Perfil extends Vue { 
        
        @authStore.Getter
		public perfis!: any 

        public model_watch  = false ;
        public modal_cadastro ;
        created(){ 
            this.modal_cadastro = 'kt_cadatrar_perfil_';
		} 
        public modeloAlterado(){  
             this.model_watch = !this.model_watch;
        }
    }
